<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>사용 중지 상태가 취소되었습니다.</span>
                    <span>지금부터 이마티콘 사용 가능합니다.</span>
                </div>
            </div>
          <div @click="closeStopUsingCancelPopup()">
            <bottom-button :buttonArray="buttonArray"></bottom-button>
          </div>
        </div>
        </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'StopUsingPopupCancel',
    components: {BottomButton},
    data() {
        return  {
            buttonArray : [
                {
                    className : "button-bg-gray",
                    text : "닫기",
                },
            ],
            barcodeNumber: false,
        }
    },
    props: ["cardInfo"],
    methods : {
        closeStopUsingCancelPopup() {
            this.$emit('stopUsingCancelPopup', false);
            this.$router.replace({ name: 'home', params: { cardInfo: this.cardInfo } })
        },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsingCancelPopup.scss';
</style>